import { render } from "./TariffPlusView.vue?vue&type=template&id=6d9528eb&scoped=true"
import script from "./TariffPlusView.vue?vue&type=script&lang=js"
export * from "./TariffPlusView.vue?vue&type=script&lang=js"

import "./TariffPlusView.vue?vue&type=style&index=0&id=6d9528eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9528eb"]])

export default __exports__